import { type ComponentProps, useEffect } from 'react';
import useExposureEvent from '@alltrails/experiments/hooks/useExposureEvent';
import useUpsellContent from '../../hooks/useUpsellContent';
import markPostAuthUpsellSeen from '../../utils/markPostAuthUpsellSeen';
import GenericPlusUpsellStep from '../UpsellSystem/GenericPlusUpsell/GenericPlusUpsellStep';

// Post-auth entry point for the in-flow Plus upsell step (for example the sign-up flow). Owns the shared
// `post-auth-upsell` snooze so that GenericPlusUpsellStep stays free of that side effect.
export default function PostAuthUpsellStep(props: ComponentProps<typeof GenericPlusUpsellStep>) {
  // The step is on screen for as long as it is mounted, so it snapshots the copy on its first render.
  const { serverUpsellContent } = useUpsellContent(props.upsellTrigger, { initiallyOpen: true });

  const sendExposureEvent = useExposureEvent(serverUpsellContent?.experimentKey);

  useEffect(() => {
    markPostAuthUpsellSeen();
  }, []);

  // Sent here, not by the flow that navigated to this step, so the exposure reflects the copy actually shown.
  useEffect(() => {
    if (serverUpsellContent?.experimentKey) {
      sendExposureEvent();
    }
  }, [serverUpsellContent?.experimentKey, sendExposureEvent]);

  return <GenericPlusUpsellStep {...props} serverUpsellContent={serverUpsellContent} />;
}
